import { Translatable } from "@icc/shared/helpers";

export class Cord {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'Profiles' })
    name: string;
    type: 'cord';
    width: number;
    img: null | string;
    normalGuide?: null | boolean;
    doubleGuide?: null | boolean;
    overlayGuide?: null | boolean;
    insetGuide?: null | boolean;
    subguide?: null | boolean;
    subguideMountedOverTopRail?: null | boolean;
    spaceLamellaMm: number;
    spaceEndRailMm: number;
    cordSupply: number;
    onEdge: boolean;
    between: boolean;
    defaultGuideHandleId: number | null;
    defaultGuideHandleIdCornerBox: number | null;
    shutterTypes: number[];
    child?: null;
    order?: number;
    default: boolean;
    length?: number | null;
    /** Długość technologiczna */
    technicalLength?: number | null;
    colorGroupSetId: number;
    printCode: string;
    /** Waga */
    weight?: number;
    /** Waga */
    weightConst?: number;
}
